import { toHoverColor, toPressColor, useTheme } from '@repo/theme';
import { createThemedStyles } from '@repo/theme/styles';
import { HoverView, Pad, PadBox } from 'component/basics';
import { UtilityText } from 'component/text';
import React from 'react';
import type { TLabel } from 'util/stdtypes';
import { makeTestID } from 'util/stdtypes';

export type FilterButtonProps = {
    emoji?: string;
    label?: TLabel;
    text?: string;
    count?: number | string;
    countColor?: string;
    selected?: boolean;
    onPress?: () => void;
};

export function FilterButton({ emoji, label, text, count, countColor, selected = false, onPress }: FilterButtonProps) {
    const { colors } = useTheme();
    const s = useFilterButtonStyles();

    return (
        <HoverView
            hoverStyle={s.hover}
            onPress={onPress}
            pressedStyle={s.pressed}
            style={[s.button, selected && s.selected]}
            testID={makeTestID({ label, text })}
        >
            {emoji && (
                <PadBox right={8}>
                    <UtilityText text={emoji} type='small' weight='medium' />
                </PadBox>
            )}
            <UtilityText label={label} text={text} type='small' weight='medium' />
            {count ? <Pad size={8} /> : null}
            <UtilityText
                color={countColor ?? colors.colorTextSecondary}
                text={count ? count.toString() : ''}
                type='small'
                weight='regular'
            />
        </HoverView>
    );
}

const useFilterButtonStyles = createThemedStyles((tokens) => ({
    button: {
        height: 32,
        flexDirection: 'row',
        alignItems: 'center',
        borderColor: tokens.colors.colorBorderPrimary,
        borderWidth: 1,
        borderRadius: 100,
        paddingHorizontal: 12,
        backgroundColor: tokens.colors.colorSurfacePrimary,
    },
    hover: {
        backgroundColor: toHoverColor(tokens.colors.colorSurfacePrimary),
    },
    pressed: {
        borderColor: tokens.colors.colorBorderPrimary,
        backgroundColor: toPressColor(tokens.colors.colorSurfacePrimary),
    },
    selected: {
        borderColor: tokens.colors.colorBorderSelected,
        backgroundColor: tokens.colors.colorSurfaceHighlight,
    },
}));
